<template>
    <div class="tagihan-card">
        <div v-for="(data, idx) in dataList" :key="`${idx}-card-tagihan`" class="items">
            <SOSlotCard :id="`tagihan-${idx}`" :card-type="typeCard">
                <template v-slot:card_head>
                    <div class="" @click="goDetailnota(data.idtransaksi)">
                        <div class="">
                            <span>{{ data.idtransaksi }}</span>
                        </div>
                    </div>
                </template>
                <template v-slot:card_body>
                    <div class="c-body" @click="goDetailnota(data.idtransaksi)">
                        <p class="m-d-0 f-13">
                            <span>
                                Transaksi {{ $moment(data.createdAt).format("DD MMM YYYY") }} oleh
                                {{ data.nama }}
                            </span>
                        </p>
                        <p class="m-d-0 f-13">
                            <span>Di outlet </span><span class="f-bold">{{ data.namaOutlet }}</span>
                            <span> • </span>
                            <span class="f-c-blue">Rp {{ data.grandtotal | decimal }}</span>
                        </p>
                    </div>
                </template>
            </SOSlotCard>
        </div>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

import SOSlotCard from "@/so-components/global/slot/SOSlotCard.vue";

import { moduleName } from "../store/state";

export default {
    name: "CardTagihan",
    props: {
        typeCard: {
            type: String,
            default: "none",
        },
        dataList: {
            type: Array,
            default: function () {
                return [];
            },
        },
    },
    components: {
        SOSlotCard,
    },
    computed: {},
    methods: {
        goDetailnota(id) {
            this.$router.push({ name: "TransaksiDetail", params: { idtransaksi: id } });
        },
    },
};
</script>
<style scoped src="../static/style.css"></style>
<style scoped>
.tagihan-card .items {
    border-bottom: 1px solid #ededed;
}
</style>
